import { Separator } from '@/components/ui/separator';
import { Card, CardContent } from '@/components/ui/card';

import { AddedMemberships, OrganizationMembers } from './';

const MembershipsManagementContainer = () => {
  return (
    <Card className="overflow-hidden">
      <CardContent className="p-0 grid gap-6 md:gap-0 grid-cols-1 md:grid-cols-[1fr_1px_1fr]">
        <AddedMemberships />
        <Separator orientation="vertical" className="hidden md:block" />
        <div className="block md:hidden px-6">
          <Separator orientation="horizontal" />
        </div>
        <OrganizationMembers />
      </CardContent>
    </Card>
  );
};

export default MembershipsManagementContainer;
